import * as VueGoogleMaps from 'vue2-google-maps'

import App from './App.vue'
import AsyncComputed from 'vue-async-computed'
import CircleMenu from 'vue-circle-menu'
import { Config } from './config.js'
import Dropdown from 'bp-vuejs-dropdown'
import UUID from 'vue-uuid'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import VueTabs from 'vue-nav-tabs'
import VueWaypoint from 'vue-waypoint'
import axios from 'axios'
import router from './router'
import store from './store/store'
import vmodal from 'vue-js-modal'

window.ifvisible = require('ifvisible.js')

Vue.use(VueCookies)
Vue.use(vmodal)
Vue.use(VueTabs)
Vue.use(UUID)
Vue.use(VueWaypoint)
Vue.use(AsyncComputed)

Vue.component('Dropdown', Dropdown)
Vue.component('CircleMenu', CircleMenu)
Vue.component(VueQrcode.name, VueQrcode)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAh9kXh7-RZ6vBlBPOMg_Ev4ktaNAt3lG8',
    libraries: 'places' // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    /// / If you want to set the version, you can do so:
    // v: '3.26',
  }

  /// / If you intend to programmatically custom event listener code
  /// / (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  /// / instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  /// / you might need to turn this on.
  // autobindAllEvents: false,

  /// / If you want to manually install components, e.g.
  /// / import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  /// / Vue.component('GmapMarker', GmapMarker)
  /// / then disable the following:
  // installComponents: true,
})
Vue.mixin({
  beforeCreate: function () {
    this.$config = Config
  }
})

Vue.use(VueAxios, axios)
Vue.use(require('vue-moment'))
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
